var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cd-select-wrapper", style: { width: _vm.width + "px" } },
    [
      _c(
        "div",
        {
          staticClass: "select-top",
          class: { topShadow: _vm.isShow, disabled: _vm.disabled },
          on: { click: _vm.toggleSelectOption }
        },
        [
          _c("span", { staticClass: "left-wrapper" }, [
            _c("input", {
              style: { width: _vm.width + "px" },
              attrs: { type: "text", readonly: "" },
              domProps: { value: _vm.currentValue }
            }),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.idx > -1
                    ? _vm.currentOption[_vm.idx][
                        _vm.headLabelKey ? _vm.valueKey : _vm.labelKey
                      ]
                    : _vm.placeholder
                )
              )
            ])
          ]),
          _c("i", { staticClass: "toDown-icon" })
        ]
      ),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.isShow
          ? _c(
              "div",
              {
                staticClass: "select-list trans_fade_image",
                class: { trans: _vm.isShow }
              },
              [
                _vm.isSearch
                  ? _c(
                      "div",
                      {
                        staticClass: "search",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.isShow = true
                          }
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchText,
                              expression: "searchText"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.searchText },
                          on: {
                            focus: function($event) {
                              $event.preventDefault()
                              _vm.isShow = true
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.searchText = $event.target.value
                            }
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._l(_vm.options, function(item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            item &&
                            item[_vm.labelKey] &&
                            item[_vm.labelKey].includes(_vm.searchText),
                          expression:
                            "item&&item[labelKey]&&item[labelKey].includes(searchText)"
                        }
                      ],
                      key: index,
                      staticClass: "cd-select-item",
                      class: {
                        checked:
                          _vm.currentValue ==
                          (_vm.valueKey ? item[_vm.valueKey] : item.value)
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectOption(item, index)
                        },
                        mousedown: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "option-wrapper",
                          class: {
                            active:
                              (_vm.valueKey
                                ? item[_vm.valueKey]
                                : item.value) == _vm.value
                          },
                          attrs: {
                            title: _vm.labelKey
                              ? item[_vm.labelKey]
                              : item.label
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.labelKey ? item[_vm.labelKey] : item.label
                            ) + " "
                          )
                        ]
                      )
                    ]
                  )
                })
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-742958c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-742958c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Select/Select.vue
// module id = undp
// module chunks = 0 1 2 3